import React from "react";
import { GlobalProvider } from "./src/context/GlobalContext";
import { AuthProvider } from "./src/context/AuthContext";
import Layout from "./src/components/Layout";
import XpToast from "./src/sections/gamification/XpToast";
import StatsModal from "./src/sections/gamification/StatsModal";
import NewsletterModal from "./src/sections/newsletter/NewsletterModal";

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>;
};

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <GlobalProvider>
      {element}
      <XpToast />
      <StatsModal />
      <NewsletterModal />
    </GlobalProvider>
  </AuthProvider>
);
